"use client";
import React from "react";
import Image from "next/image";
import VideoPlayer from "./VideoPlayer";
import isImage from "@/lib/isImage";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Import Material UI Close Icon
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useImageUrlModifier from "@/lib/useImageUrlModifier";

interface ImageSliderDialogProps {
  open: boolean;
  onClose: () => void;
  images: string[];
  fallbackImage: string;
  isStock: boolean;
  product: any;
}

const ImageSliderDialog: React.FC<ImageSliderDialogProps> = ({
  open,
  onClose,
  images,
  fallbackImage,
  isStock,
  product,
}) => {
  const modifyImageUrl = useImageUrlModifier();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        style: { backgroundColor: "white", boxShadow: "none" },
      }}
    >
      <DialogContent style={{ overflow: "hidden" }}>
        {/* Close Icon */}
        <IconButton
          onClick={onClose}
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            color: "black",
            zIndex: 1000,
          }}
        >
          <CloseIcon style={{ fontSize: "2rem" }} />{" "}
        </IconButton>

        <div className="relative h-screen w-full py-8">
          <Swiper
            modules={[Navigation, Pagination]}
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={1}
            pagination={{ clickable: true }}
            navigation={{
              prevEl: ".swiper-button-prev",
              nextEl: ".swiper-button-next",
            }}
            className="mySwiper h-full flex justify-center items-center"
          >
            {images.map((image, index) => (
              <SwiperSlide
                key={index}
                className="relative h-full aspect-square"
              >
                <div className="h-full flex justify-center items-center">
                  {isImage(image) ? (
                    <Image
                      src={modifyImageUrl(image, 500, 500) || ""}
                      fill={true}
                      objectFit="contain"
                      alt={`Product image ${index + 1}`}
                      quality={80}
                      priority={true}
                      placeholder="blur"
                      blurDataURL={fallbackImage}
                      sizes="auto"
                      className="aspect-square"
                    />
                  ) : (
                    <VideoPlayer
                      videoUrl={image?.replace(/^https:\/\/res\.cloudinary\.com/, "https://res.cloudinary.com")}
                      play={false}
                      stock={isStock ? true : false}
                      productId={product?.data?.id}
                    />
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Buttons */}
          <div
            className="swiper-button-prev"
            style={{
              color: "#AC7529",
              position: "absolute",
              left: "16px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1000,
              cursor: "pointer",
            }}
          ></div>
          <div
            className="swiper-button-next"
            style={{
              color: "#AC7529",
              position: "absolute",
              right: "16px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1000,
              cursor: "pointer",
            }}
          ></div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageSliderDialog;
